export default __webpack_public_path__ + "Lisa Murray.5d0de6b4c73c4b3b6874.png";